(() => {
  const SELECTOR = '[data-tw-roadmap]';

  function initializeRoadmap(root) {
    if (!root || root.dataset.twInitialized === 'true') {
      return;
    }

    root.dataset.twInitialized = 'true';

    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      root
        .querySelectorAll('[data-reveal]')
        .forEach((element) => element.classList.add('is-visible'));

      return;
    }

    root.classList.add('is-ready');

    const revealElements = root.querySelectorAll('[data-reveal]');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    revealElements.forEach((element, index) => {
      element.style.transitionDelay = `${Math.min(index % 3, 2) * 70}ms`;
      observer.observe(element);
    });
  }

  function initializeAllRoadmaps(container = document) {
    container
      .querySelectorAll(SELECTOR)
      .forEach((root) => initializeRoadmap(root));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAllRoadmaps();
    });
  } else {
    initializeAllRoadmaps();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllRoadmaps(event.target);
  });
})();